/**
 * Marca "SA" — cuadrado con solo el borde en rojo, interior transparente
 * (deja ver el fondo real de detrás, así funciona igual en tema claro y
 * oscuro) y las letras S en rojo, A en el color de texto del tema activo.
 *
 * Es SVG inline (no <img src="...">) a propósito: un <img> que apunta a un
 * archivo .svg no puede leer las variables CSS de la página, así que se
 * quedaría siempre con los colores fijos del archivo. Inline sí puede.
 */
export default function BrandMark({ size = 28, style }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 512 512"
      style={{ flexShrink: 0, borderRadius: size * 0.28, ...style }}
    >
      <rect x="16" y="16" width="480" height="480" rx="96" fill="none" stroke="var(--red)" strokeWidth="26" />
      <text x="256" y="256" dominantBaseline="central" fontFamily="'Segoe UI', Arial, sans-serif" fontWeight="900" fontSize="236" textAnchor="middle">
        <tspan fill="var(--red)">S</tspan><tspan fill="var(--text)">A</tspan>
      </text>
    </svg>
  );
}
